import { type Auth, onAuthStateChanged, type User } from 'firebase/auth';

export const AUTH_SESSION_RESTORE_WAIT_MS = 15_000;

/** Wait for Firebase persistence / silent Microsoft auth to restore a user. */
export function waitForFirebaseUser(
  auth: Auth,
  timeoutMs = AUTH_SESSION_RESTORE_WAIT_MS,
): Promise<User | null> {
  if (auth.currentUser) return Promise.resolve(auth.currentUser);

  return new Promise((resolve) => {
    let settled = false;
    let unsubscribe: () => void = () => {};
    let timeout = 0;
    const finish = (user: User | null) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      unsubscribe();
      resolve(user);
    };
    timeout = window.setTimeout(() => finish(auth.currentUser), timeoutMs);
    unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) finish(user);
    });
    if (settled) unsubscribe();
  });
}
